export default __webpack_public_path__ + "static/40-Yard-Dumpster-26ed5a8f85ed70f677440b8008141131.jpg";